(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-featured-in"] && !window.DesignMode) return;
  try {
    

var logos = document.querySelectorAll(".testimonial-image");
var shownTestimonial = document.querySelectorAll(".shown");


for (let i = 0; i < logos.length; i++) {
                                 
	logos[i].addEventListener('mouseover', ()=>{

		for (let index = 0; index < shownTestimonial.length; index++) {                                      
			shownTestimonial[index].classList.remove('shown');
        }

		var testimonialId = logos[i].getAttribute('data-testimonial-id');
		var testimonialElement = document.getElementById(testimonialId);

		testimonialElement.classList.add('show');

	});

	logos[i].addEventListener('mouseout', ()=>{

		var testimonialId = logos[i].getAttribute('data-testimonial-id');
		var testimonialElement = document.getElementById(testimonialId);

		testimonialElement.classList.remove('show');

	});
                                                                                     
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    
    
  function scrollToHash() {
    let hash = window.location.hash;
    if (!hash) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('customer_posted') == 'true') {
        hash = '#contact_form';
      } else {
        return;
      }
    }
    // find the element
    const el = document.querySelector(hash);
    el.scrollIntoView({
      block: "center"
    });
  }

  window.addEventListener('load', (event) => {
    scrollToHash();
  });
  

  } catch(e) { console.error(e); }
})();
})();
